const constants = {
	ROUTE: {
		REGISTER: 'REGISTER',
		LOGIN: 'LOGIN',
		FORGOT_PASSWORD: 'FORGOT_PASSWORD',
		HOME: 'HOME',
		TRADING: 'TRADING',
		WALLET_MAIN: 'WALLET_MAIN',
		WALLET: 'WALLET',
		PROFILE: 'PROFILE',
		DASHBOARD: 'DASHBOARD',
		AFFILIATE: 'AFFILIATE',
		DEPOSIT: 'DEPOSIT',
		TRANSFER: 'TRANSFER',
		AGENCY: 'AGENCY',
		CHALLENGE: 'CHALLENGE',
		STREAK_CHALLENGE: 'STREAK_CHALLENGE',
		NOTIFICATION: 'NOTIFICATION',
	},

	TRANSACTION_STATUS: {
		PENDING: 'pending',
		FINISH: 'finish',
	},

	TRANSACTION_TYPE: {
		BET: 'bet',
		RECHARGE: 'recharge',
		WITHDRAWAL: 'withdrawal',
		TRANSACTION_TO_MAIN: "transaction_to_main",
		MAIN_TO_TRANSACTION: "main_to_transaction"
	},

	BASE_URL: process.env.REACT_APP_BASE_URL,
	BASE_API: process.env.REACT_APP_API_URL,
	SERVER_TIMEOUT: 30000,

	CHALLENGE_TYPE: {
		TRADING: 'trading',
		AGENCY: 'agency',
	},
	CHALLENGE_SCHEDULE: {
		MONTH: 'month',
		WEEK: 'week',
	}
}

export default constants;
